<template>
  <div class="charge">
    <div class="toolBar">
      <p>
        <label>患者姓名：</label>
        <Input v-model="name" placeholder="患者姓名" />
      </p>
      <p>
        <label>医生：</label>
        <Input v-model="doctor" placeholder="医生"/>
      </p>
      <p>
        <label>自定义日期：</label>
        <DatePicker type="date" :options="options3" format="yyyy-MM-dd" placeholder="开始日期" v-model="startDate" @on-change="startTime"></DatePicker>
         —
        <DatePicker type="date" :options="options3" format="yyyy-MM-dd" placeholder="结束日期" v-model="endDate" @on-change="endTime"></DatePicker>
      </p>
      <p>
        <Button type="primary" @click="search">查询</Button>
      </p>
    </div>
    <div class="mainBox">
       <Table :height="tableHeight" ref="table" :columns="columns1" :data="data1"></Table>
       <div class="pageBox">
         <Page :total="total" :transfer='true' show-elevator show-sizer @on-change="changePage" @on-page-size-change="changePageSize" />
       </div>
    </div>
    <Modal 
      :mask-closable="false"
      width="60%"
      :name="modelName"
      v-model="modal2"
      :title="modelTitle"
      :scrollable="true"
      @on-ok="confirm"
      @on-cancel="cancel">
      <div class="settleBox">
        <div class="projectBox">
          <ul>
            <li>
              <p>条形码</p>
              <p>标本类型</p>
              <p>总量</p>
              <p>单位</p>
              <p>采集容器</p>
              <p>个数</p>
            </li>
            <li v-for="(project,index) in projectShowItems" :key="index">
              <div>
                <p><Input @on-keyup="project.specimenBarcodes=project.specimenBarcodes.replace(/^ +| +$/g,'')" v-model="project.specimenBarcodes" placeholder="条形码"/></p>
                <p>{{project.specimenTypeName}}</p>
                <p>{{project.count}}</p>
                <p>{{project.unitName}}</p>
                <p>{{project.samplingColor}}</p>
                <p><InputNumber v-model="project.samplingNum" :min="1"></InputNumber></p>
              </div>
              <div class="proBox" v-if="project.list">
                <p></p>
                <div>
                  <p v-for="(item,subIndex) in project.list" :key="subIndex">
                    {{item.projectName}}
                  </p>
                </div>
               
              </div>
            </li>
          </ul>
        </div>
        <div class="dateBox">
          <p>采样时间：</p>
          <DatePicker type="date" format="yyyy-MM-dd HH:mm" placeholder="选择采样时间" style="width: 200px" v-model="samplingTime" @on-change="sampTime"></DatePicker>
        </div>
        <!-- <div class="uploadBox">
          <div>
            <p>
            附件:点击上传申请单。
            </p>
            <p><Button type="primary" @click="upload">上传</Button></p>
            <div class="imgBox">
              <span v-for="(img,index) in imgSrcList" v-bind:key="index" v-viewer>
                <img :src="img.url" :alt="img.name" >
              </span>
              <Upload
                  multiple
                  ref="upload"
                  type="drag"
                  :action="uploadAction"
                  :before-upload="beforeUpload"
                  :on-success="successUpload"
                  :show-upload-list="false"
                  >
                  <span>
                    <i class="iconfont icon-jia"></i>
                  </span>
              </Upload>
            </div>
          </div>
        </div> -->
      </div>
      <div slot="footer">
          <Button type="text" size="large" @click="cancel">取消</Button>
          <Button type="primary" size="large" @click="confirm">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import {noAccountList,settleAccount} from '../../../api/outside';
import {samplingDetail} from '../../../api/clinic'
import { tips,replaceT,payType,arrTostring,formatState,compareDate } from "../../../tools";
export default {
  name: 'NoSamp',
  inject:['reload'],
  data () {
    return {
      tableHeight:632,
      options3:{
        disabledDate (date) {
          return date && date.valueOf() > Date.now();
        }
      },
      isShow:true,//收费还是详情
      modal2:false,
      modelName:'',
      modelTitle:'',
      samplingTime:'',
      total:0,
      pageCurrent:1,
      pageSize: 10,
      name:'',//患者姓名/手机号
      doctor:'',//医生
      startDate:'',//开始日期
      endDate:'',//结束日期
      projectShowItems:[],
      samplingTime:'',//采样时间
      hospitalProjectIds:[],
      hospitalCaseId:0,
      columns1:[
        {
          title: '患者',
          key: 'hospitalPatientName',
          align:'center'
        },
        {
          title: '电话',
          key: 'mobile',
          align:'center'
        },
        {   
          title: '性别',
          key: 'sex',
          align:'center',
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: params.row.sex==1?'男':'女' 
              },
            })
          }
        },
        {
            title: '年龄',
            key: 'age',
            align:'center'
        },
        {
            title: '年龄单位',
            key: 'ageUnit',
            align:'center'
        },
        {
            title: '医生',
            key: 'doctorName',
            align:'center'
        },
        {
          minWidth:150,
          title: '项目名称',
          key: 'hisProjectVoNames',
          align:'center',
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              },
              domProps: {
                title:params.row.hisProjectVoNames,
                innerHTML: arrTostring(params.row.hisProjectVoNames) 
              },
            })
          }
        },
        {
            title: '就诊日期',
            key: 'diagnosisTime',
            align:'center',
            // render:(h,params) =>{
            //   return replaceT(params.row.diagnosisTime);
            // }
            render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: replaceT(params.row.diagnosisTime) 
              },
            })
          }
        },
        {
            title: '总金额(元)',
            key: 'amount',
            align:'center'
        },
        
        {
          title: '操作',
          align:'center',
          key: 'methods',
          align: 'center',
          width:100,
          render: (h, params) => {
            return h('div',{
              style: {
                  textAlign: 'center'
                }
              },
              [
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-shoufei3'
                  },
                  style: {
                    textAlign:'center',
                    margin:' 0 5px 0',
                    borderColor:'#2778E7',
                    color:'#2778E7'
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      this.modal2 = true;
                      this.modelName = 'sampDetail';
                      this.modelTitle = '采集详情';
                      let ids = params.row.hisProjectIds;
                      this.hospitalProjectIds = params.row.hisProjectIds;
                      this.hospitalCaseId = params.row.id;
                      this.samplingDetail(ids);
                    },
                  }
                }, '采集')
            ]);
          }
        }
      ],
      data1:[],
    }
  },
  created(){
    let lett = this;
    document.onkeydown = function(e) {
    let key = window.event.keyCode;
    if (key == 13) {
      lett.search();
      }
    }
  },
  mounted(){
    window.addEventListener('resize', this.getTableHeight);
    this.getTableHeight();
    this.loadList();
  },
  methods:{
    getTableHeight(){
      // 设置表格高度 
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop-90; 
    },
    loadList(){
      this.search();
    },
    //搜索
    search(){
      let _this = this;
      let params = {
        current: _this.pageCurrent,
        endTimes: _this.endDate,
        name: _this.doctor,
        nameAndPhone: _this.name,
        size: _this.pageSize,
        starTimes: _this.startDate
      };
      noAccountList(
        params
      ).then(res => {
        let data = res.records;
        _this.total = res.total;
        _this.data1 = data;
      });
    }, 
    //采集要求
    samplingDetail(ids){
      let _this = this;
      // console.log(ids);
      samplingDetail({
        orderIds: ids
      }).then(res => {
        console.log(res);
        _this.projectShowItems = res;
      });
    },
    //改变页码
    changePage(current){
      this.pageCurrent = current;
      this.loadList();
    },
    //改变每页条数
    changePageSize(size){
      this.pageSize = size;
      this.loadList();
    },
    confirm(){
      let _this = this;
      let specimenArr = [];
      let proItems = _this.projectShowItems;
      let obj = {
        projectIds: [
          0
        ],
        samplingColor: "",
        samplingNum: 0,
        specimenBarcodes: "",
        specimenType: ""
      }
      for(let i=0;i<proItems.length;i++){
        obj.projectIds = proItems[i].peojects;
        obj.samplingColor = proItems[i].samplingColor;
        obj.samplingNum = proItems[i].samplingNum;
        obj.specimenBarcodes = proItems[i].specimenBarcodes;
        obj.specimenType = proItems[i].specimenType;
        specimenArr.push(obj);
      }
      // console.log(specimenArr);
      
      let params = {
        hospitalCaseId: _this.hospitalCaseId,
        hospitalProjectIds: _this.hospitalProjectIds,
        samplingTime: _this.samplingTime,
        specimenSamplingParams: specimenArr
      }
      // console.log(params);
      let SamplingParams =  params.specimenSamplingParams;
      let barCodeIndex = SamplingParams.findIndex(item=>item.specimenBarcodes==undefined||item.specimenBarcodes=='');
      let samplingNumIndex = SamplingParams.findIndex(item=>item.samplingNum==0);
      console.log(barCodeIndex);
      console.log(samplingNumIndex);
      
      if(params.samplingTime==''){
        tips(_this,'采样时间不能为空！','warning');
      }else if(barCodeIndex!=-1){
        tips(_this,'条形码不能为空！','warning');
      }else if(samplingNumIndex!=-1){
        tips(_this,'数量不能为空！','warning');
      }else{
        // alert(111)
        console.log(params);
        _this.specimenBarCode(params);
      }
      
    },
     //结算
    specimenBarCode(params){
      settleAccount(
        params
      ).then(res=>{
        console.log(res);
        tips(this,res,'success');
        this.reload();
      });
    },
    cancel(){
      this.modal2 = false;
    },
    //开始日期格式化
    
    startTime(e){
      this.startDate = e;
    },
    endTime(e){
      this.endDate = e;
    },
    sampTime(e){
      this.samplingTime = e;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
.charge{

}
.charge .toolBar{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap ;
  padding: 10px 0;
}
.charge .toolBar>p{
  padding: 5px 0;
  margin-right: 20px;
}
.charge .toolBar>p>label{
  display: inline-block;
}
.pageBox{
  text-align: center;
  padding: 5px 0;
}
.ivu-input-wrapper{
  width: 120px;
}
.ivu-select{
  width: 120px;
  /* width: 100%; */
}
.ivu-date-picker{
  width: 120px;
}

/* 详情弹框 */
.accountBox{
  width: 100%;
}
.accountBox /deep/ .ivu-modal{
  height: 600px;
  overflow: hidden;
}
.accountBox /deep/ .ivu-modal-content{
  height: 100%;
  overflow: hidden;
}
.ivu-modal-body{
  font-size: 14px;
  overflow: scroll;
  height: 300px;
}
.basiInfo{
  display: flex;
  flex-flow: wrap row;
  justify-content: flex-start;
  padding: 8px 10px 8px;
  border-bottom: 1px solid #c9c9c9;
}
.basiInfo>p{
  margin-right: 30px;
  line-height: 32px;
}
.basiInfo>p>span:nth-child(2){
  padding-right: 30px;
  border-right: 1px solid #c9c9c9;
}
.basiInfo .keyName{
  color: #2778e2;
}
.projectBox>ul{
  border: 1px solid #c9c9c9;
}
.projectBox>ul>li:first-child{
  display: flex;
  justify-content: space-between;
  flex-flow: row nowrap;
  padding: 5px;
  border-bottom: 1px solid #c9c9c9;
}
.projectBox>ul>li:last-child{
  border: none;
}
.projectBox>ul>li:first-child>p{
  color:#515a6e;
  font-weight: bold;
}
.projectBox>ul>li>div{
  display: flex;
  justify-content: space-between;
  flex-flow: row nowrap;
  padding: 5px;
  border-bottom: 1px solid #c9c9c9;
  width: 100%;
}
.projectBox>ul>li>div.proBox{
  justify-content: flex-start;
}
.projectBox>ul>li>div.proBox>div{
  width: 80%;
}
.projectBox>ul>li>div.proBox>div>p{
  line-height: 32px;
  position: relative;
}

.projectBox>ul>li>p:first-child{
  width: 20%;
}
.projectBox>ul>li>div>p:first-child {
    width: 20%;
}
.projectBox>ul>li>div>p{
  width: 16%;
  text-align: center;
  line-height: 32px;
  min-width: 100px;
}
.projectBox>ul>li>p {
    width: 16%;
    text-align: center;
    line-height: 32px;
}
.dateBox{
  display: flex;
  justify-content: flex-start;
  padding:10px;
}
.dateBox>p{
  min-width: 65px;
  width: 10%;
  line-height: 32px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/samp/nosamp/NoSamp.vue